import * as React from "react";

import FlowForm from "../../components/Forms/ParkingSpot/FlowForm/FlowForm";

export default () => {
  return <FlowForm method="POST" />;
};
